import React from 'react';
import { connect } from 'react-redux';

import DemandeList from '../../List/Demande/DemandeList';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      filter,
      service,
      sort = { id: -1 },
      count = 10,
      handlerFilterByColumns,
      filteredByColumn = false,
    },
  },
}) => ({
  filter,
  service,
  sort,
  handlerFilterByColumns,
  filteredByColumn,
  count
});

const DemandeListDialog = ({
  filter,
  service,
  sort,
  count,
  handlerFilterByColumns,
  filteredByColumn,
}) => (
  <DemandeList
    small
    filter={filter}
    count={count}
    filteredByColumn={filteredByColumn}
    service={service}
    sort={sort}
    handlerFilterByColumns={handlerFilterByColumns}
  />
);
export default connect(mapStateToProps)(DemandeListDialog);
